import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { 
  Search, 
  Filter, 
  Plus, 
  Eye, 
  Edit, 
  Download,
  Calendar,
  Package,
  Truck,
  Ship,
  User,
  Building,
  MapPin,
  Shield,
  Upload,
  X,
  Navigation,
  ArrowRight,
  FileText,
  CheckCircle,
  Circle,
  Trash2,
  FileEdit,
  Printer
} from 'lucide-react';

// Modal pour la facturation avant impression
const BillingModal = ({ isOpen, saisie, onClose, onPrint }) => {
  const [billingData, setBillingData] = useState({
    // Transport Services
    unloadingLoadingTruck: false,
    onboardDelivery: false,
    assistanceToTruckDriver: false,
    handlingInOutWh: false,
    truckingAssistance: false,
    
    //Driver
    truckPlate: '',
    driverName: '',

    // Customs Services
    customsClearance: false,
    ist: false,
    rts: false,
    docCustomsIssuedBy: '',
    atl: false,
    dhlFedex: false,
    
    // Airport Services
    feeOnArrival: false,
    pickingUpForWh: false,
    pickingUpForDelivery: false,
    
    // Other Services
    collectionAndTransport: false,
    pickUpExpedition: false,
    storageFee: false,
    
    // Montants
    htAmount: '',
    vtAmount: '',
    
    // Notes
    notes: ''
  });

  if (!isOpen) return null;

  const handleCheckboxChange = (field) => {
    setBillingData(prev => ({
      ...prev,
      [field]: !prev[field]
    }));
  };

  const handleInputChange = (field, value) => {
    setBillingData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handlePrint = () => {
    // Ici vous pouvez implémenter la logique d'impression avec les données de facturation
    console.log('Impression de la pochette A3 avec données de facturation:', {
      saisie: saisie.id,
      billing: billingData
    });
    onPrint(billingData);
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-4xl mx-4 max-h-screen overflow-y-auto">
        <div className="flex items-center justify-between mb-6">
          <h3 className="text-2xl font-bold text-port-gray-900">
            Éléments de facturation - Saisie #{saisie?.id}
          </h3>
          <button onClick={onClose} className="btn-secondary">
            <X className="h-5 w-5" />
          </button>
        </div>

        <div className="space-y-6">
          {/* Transport Services */}
          <div className="bg-gray-100 p-4 rounded-lg">
            <h4 className="text-lg font-semibold text-center mb-4 bg-gray-300 p-2 rounded">
              TRANSPORT SERVICES
            </h4>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <label className="flex items-center space-x-2">
                <input
                  type="checkbox"
                  checked={billingData.unloadingLoadingTruck}
                  onChange={() => handleCheckboxChange('unloadingLoadingTruck')}
                  className="h-4 w-4 text-atl-blue-600 border-gray-300 rounded focus:ring-atl-blue-500"
                />
                <span>UNLOADING/LOADING TRUCK</span>
              </label>
              
              <label className="flex items-center space-x-2">
                <input
                  type="checkbox"
                  checked={billingData.handlingInOutWh}
                  onChange={() => handleCheckboxChange('handlingInOutWh')}
                  className="h-4 w-4 text-atl-blue-600 border-gray-300 rounded focus:ring-atl-blue-500"
                />
                <span>HANDLING IN/OUT WH</span>
              </label>
              
              <label className="flex items-center space-x-2">
                <input
                  type="checkbox"
                  checked={billingData.onboardDelivery}
                  onChange={() => handleCheckboxChange('onboardDelivery')}
                  className="h-4 w-4 text-atl-blue-600 border-gray-300 rounded focus:ring-atl-blue-500"
                />
                <span>ONBOARD DELIVERY</span>
              </label>
              
              <label className="flex items-center space-x-2">
                <input
                  type="checkbox"
                  checked={billingData.truckingAssistance}
                  onChange={() => handleCheckboxChange('truckingAssistance')}
                  className="h-4 w-4 text-atl-blue-600 border-gray-300 rounded focus:ring-atl-blue-500"
                />
                <span>TRUCKING ASSISTANCE</span>
              </label>
              
              <label className="flex items-center space-x-2">
                <input
                  type="checkbox"
                  checked={billingData.assistanceToTruckDriver}
                  onChange={() => handleCheckboxChange('assistanceToTruckDriver')}
                  className="h-4 w-4 text-atl-blue-600 border-gray-300 rounded focus:ring-atl-blue-500"
                />
                <span>ASSISTANCE TO TRUCK/DRIVER</span>
              </label>
            </div>

          {/* Driver */}

            <div className="mt-4">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Truck Plate
                  </label>
                  <input
                    type="text"
                    value={billingData.truckPlate}
                    onChange={(e) => handleInputChange('truckPlate', e.target.value)}
                    className="input-field w-full max-w-sm"
                    placeholder="Truck Plate"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Driver Name
                  </label>
                  <input
                    type="text"
                    value={billingData.driverName}
                    onChange={(e) => handleInputChange('driverName', e.target.value)}
                    className="input-field w-full max-w-sm"
                    placeholder="Driver Name"
                  />
                </div>
              </div>
            </div>

          </div>

          {/* Customs Services */}
          <div className="bg-gray-100 p-4 rounded-lg">
            <h4 className="text-lg font-semibold text-center mb-4 bg-gray-300 p-2 rounded">
              CUSTOMS SERVICES
            </h4>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <label className="flex items-center space-x-2">
                <input
                  type="checkbox"
                  checked={billingData.customsClearance}
                  onChange={() => handleCheckboxChange('customsClearance')}
                  className="h-4 w-4 text-atl-blue-600 border-gray-300 rounded focus:ring-atl-blue-500"
                />
                <span>CUSTOMS CLEARANCE</span>
              </label>
              
              <label className="flex items-center space-x-2">
                <input
                  type="checkbox"
                  checked={billingData.ist}
                  onChange={() => handleCheckboxChange('ist')}
                  className="h-4 w-4 text-atl-blue-600 border-gray-300 rounded focus:ring-atl-blue-500"
                />
                <span>IST</span>
              </label>
              
              <label className="flex items-center space-x-2">
                <input
                  type="checkbox"
                  checked={billingData.rts}
                  onChange={() => handleCheckboxChange('rts')}
                  className="h-4 w-4 text-atl-blue-600 border-gray-300 rounded focus:ring-atl-blue-500"
                />
                <span>RTS</span>
              </label>
              
              <label className="flex items-center space-x-2">
                <input
                  type="checkbox"
                  checked={billingData.atl}
                  onChange={() => handleCheckboxChange('atl')}
                  className="h-4 w-4 text-atl-blue-600 border-gray-300 rounded focus:ring-atl-blue-500"
                />
                <span>ATL</span>
              </label>
              
              <label className="flex items-center space-x-2">
                <input
                  type="checkbox"
                  checked={billingData.dhlFedex}
                  onChange={() => handleCheckboxChange('dhlFedex')}
                  className="h-4 w-4 text-atl-blue-600 border-gray-300 rounded focus:ring-atl-blue-500"
                />
                <span>DHL - FEDEX ...</span>
              </label>
            </div>
            
            <div className="mt-4">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                DOC CUSTOMS ISSUED BY :
              </label>
              <input
                type="text"
                value={billingData.docCustomsIssuedBy}
                onChange={(e) => handleInputChange('docCustomsIssuedBy', e.target.value)}
                className="input-field w-full max-w-md"
                placeholder="Nom de l'organisme..."
              />
            </div>
          </div>

          {/* Airport Services */}
          <div className="bg-gray-100 p-4 rounded-lg">
            <h4 className="text-lg font-semibold text-center mb-4 bg-gray-300 p-2 rounded">
              AIRPORT SERVICES
            </h4>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <label className="flex items-center space-x-2">
                <input
                  type="checkbox"
                  checked={billingData.feeOnArrival}
                  onChange={() => handleCheckboxChange('feeOnArrival')}
                  className="h-4 w-4 text-atl-blue-600 border-gray-300 rounded focus:ring-atl-blue-500"
                />
                <span>FEE ON ARRIVAL</span>
              </label>
              
              <label className="flex items-center space-x-2">
                <input
                  type="checkbox"
                  checked={billingData.pickingUpForWh}
                  onChange={() => handleCheckboxChange('pickingUpForWh')}
                  className="h-4 w-4 text-atl-blue-600 border-gray-300 rounded focus:ring-atl-blue-500"
                />
                <span>PICKING UP FOR WH</span>
              </label>
              
              <label className="flex items-center space-x-2">
                <input
                  type="checkbox"
                  checked={billingData.pickingUpForDelivery}
                  onChange={() => handleCheckboxChange('pickingUpForDelivery')}
                  className="h-4 w-4 text-atl-blue-600 border-gray-300 rounded focus:ring-atl-blue-500"
                />
                <span>PICKING UP FOR DELIVERY</span>
              </label>
            </div>
          </div>

          {/* Other Services */}
          <div className="bg-gray-100 p-4 rounded-lg">
            <h4 className="text-lg font-semibold text-center mb-4 bg-gray-300 p-2 rounded">
              OTHER SERVICES
            </h4>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <label className="flex items-center space-x-2">
                <input
                  type="checkbox"
                  checked={billingData.collectionAndTransport}
                  onChange={() => handleCheckboxChange('collectionAndTransport')}
                  className="h-4 w-4 text-atl-blue-600 border-gray-300 rounded focus:ring-atl-blue-500"
                />
                <span>COLLECTION AND TRANSPORT</span>
              </label>
              
              <label className="flex items-center space-x-2">
                <input
                  type="checkbox"
                  checked={billingData.pickUpExpedition}
                  onChange={() => handleCheckboxChange('pickUpExpedition')}
                  className="h-4 w-4 text-atl-blue-600 border-gray-300 rounded focus:ring-atl-blue-500"
                />
                <span>PICK UP/EXPEDITION</span>
              </label>
              
              <label className="flex items-center space-x-2">
                <input
                  type="checkbox"
                  checked={billingData.storageFee}
                  onChange={() => handleCheckboxChange('storageFee')}
                  className="h-4 w-4 text-atl-blue-600 border-gray-300 rounded focus:ring-atl-blue-500"
                />
                <span>STORAGE FEE</span>
              </label>
            </div>
          </div>

          {/* Montants */}
          <div className="bg-gray-100 p-4 rounded-lg">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  HA (€ HT)
                </label>
                <input
                  type="number"
                  step="0.01"
                  value={billingData.htAmount}
                  onChange={(e) => handleInputChange('htAmount', e.target.value)}
                  className="input-field"
                  placeholder="0.00"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  VT (€ HT)
                </label>
                <input
                  type="number"
                  step="0.01"
                  value={billingData.vtAmount}
                  onChange={(e) => handleInputChange('vtAmount', e.target.value)}
                  className="input-field"
                  placeholder="0.00"
                />
              </div>
            </div>
          </div>

          {/* Notes */}
          <div className="bg-gray-100 p-4 rounded-lg">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Notes
            </label>
            <textarea
              value={billingData.notes}
              onChange={(e) => handleInputChange('notes', e.target.value)}
              className="input-field w-full"
              rows={4}
              placeholder="Notes additionnelles..."
            />
          </div>
        </div>

        {/* Actions */}
        <div className="flex justify-end space-x-3 mt-6 pt-6 border-t">
          <button onClick={onClose} className="btn-secondary">
            Annuler
          </button>
          <button 
            onClick={handlePrint}
            className="btn-primary flex items-center space-x-2"
          >
            <Printer className="h-4 w-4" />
            <span>Imprimer la pochette A3</span>
          </button>
        </div>
      </div>
    </div>
  );
};

// Modal pour afficher les détails d'une saisie
const SaisieDetailModal = ({ isOpen, saisie, onClose, onEdit, onOpenBilling }) => {
  if (!isOpen || !saisie) return null;

  const getStepIcon = (stepType) => {
    switch(stepType) {
      case 'Origine': return <MapPin className="h-5 w-5" />;
      case 'Destination': return <Ship className="h-5 w-5" />;
      case 'Entrepot ATL': return <Building className="h-5 w-5" />;
      case 'Entrepot ATL Douane': return <Shield className="h-5 w-5" />;
      default: return <Circle className="h-5 w-5" />;
    }
  };

  const getStepColor = (stepType) => {
    switch(stepType) {
      case 'Origine': return 'bg-atl-blue-600';
      case 'Destination': return 'bg-atl-green-600';
      case 'Entrepot ATL': return 'bg-port-gray-600';
      case 'Entrepot ATL Douane': return 'bg-yellow-600';
      default: return 'bg-port-gray-400';
    }
  };

  const renderStepsOverview = () => {
    if (!saisie.steps || saisie.steps.length === 0) {
      return (
        <div className="text-center py-8 text-port-gray-500">
          <Navigation className="h-12 w-12 mx-auto mb-3 opacity-50" />
          <p>Aucune étape définie</p>
        </div>
      );
    }

    const sortedSteps = [...saisie.steps].sort((a, b) => (a.sortOrder || 0) - (b.sortOrder || 0));

    // Fonction pour obtenir les transports liés à une étape
    const getTransportsForStep = (stepId, before = true) => {
      if (!saisie.transports) return [];
      return saisie.transports.filter(transport => 
        transport.entryStepId == stepId && (transport.transportBeforeStep || false) === before
      );
    };

    // Fonction pour afficher tous les transports non liés aux étapes
    const getUnlinkedTransports = () => {
      if (!saisie.transports) return [];
      return saisie.transports.filter(transport => !transport.entryStepId);
    };

    const renderTransportInfo = (transports) => {
      if (transports.length === 0) return null;
      
      return (
        <div className="flex flex-col items-center space-y-1">
          {transports.map(transport => (
            <div key={transport.id} className="text-center">
              <div className="w-8 h-8 rounded-full bg-orange-500 flex items-center justify-center text-white">
                <Truck className="h-4 w-4" />
              </div>
              <div className="text-xs text-port-gray-600 max-w-20 truncate">
                {transport.transporteurName || 'Transporteur'}
              </div>
              {transport.transporteurTrackingNumber && (
                <div className="text-xs text-port-gray-500 max-w-20 truncate">
                  {transport.transporteurTrackingNumber}
                </div>
              )}
            </div>
          ))}
        </div>
      );
    };

    const unlinkedTransports = getUnlinkedTransports();

    return (
      <div className="space-y-4">
        <div className="flex items-center justify-center space-x-4 py-4 flex-wrap">
          {sortedSteps.map((step, index) => {
            const transportsBefore = getTransportsForStep(step.id, true);
            const transportsAfter = getTransportsForStep(step.id, false);
            
            return (
              <React.Fragment key={step.id}>
                {/* Transports avant l'étape */}
                {transportsBefore.length > 0 && (
                  <>
                    {renderTransportInfo(transportsBefore)}
                    <ArrowRight className="h-4 w-4 text-orange-400" />
                  </>
                )}
                
                {/* L'étape elle-même */}
                <div className="flex flex-col items-center space-y-2">
                  <div className={`w-12 h-12 rounded-full flex items-center justify-center text-white font-medium ${getStepColor(step.stepType)}`}>
                    {getStepIcon(step.stepType)}
                  </div>
                  <div className="text-center">
                    <div className="font-medium text-port-gray-900">{step.stepType}</div>
                    <div className="text-sm text-port-gray-600 max-w-32 truncate">
                      {step.entityLinkedName || ''}
                    </div>
                    {step.dateStep && (
                      <div className="text-xs text-port-gray-500 flex items-center mt-1">
                        <Calendar className="h-3 w-3 mr-1" />
                        {new Date(step.dateStep).toLocaleDateString('fr-FR')}
                      </div>
                    )}
                  </div>
                </div>
                
                {/* Transports après l'étape */}
                {transportsAfter.length > 0 && (
                  <>
                    <ArrowRight className="h-4 w-4 text-orange-400" />
                    {renderTransportInfo(transportsAfter)}
                  </>
                )}
                
                {/* Flèche vers l'étape suivante */}
                {index < sortedSteps.length - 1 && (
                  <ArrowRight className="h-6 w-6 text-port-gray-400" />
                )}
              </React.Fragment>
            );
          })}
        </div>
        
        {/* Transports non liés aux étapes */}
        {unlinkedTransports.length > 0 && (
          <div className="border-t pt-4">
            <div className="text-center mb-2">
              <span className="text-sm text-port-gray-600 bg-port-gray-100 px-3 py-1 rounded-full">
                Transports non liés aux étapes
              </span>
            </div>
            <div className="flex items-center justify-center space-x-4">
              {renderTransportInfo(unlinkedTransports)}
            </div>
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-6xl mx-4 max-h-screen overflow-y-auto">
        <div className="flex items-center justify-between mb-6">
          <h3 className="text-2xl font-bold text-port-gray-900">
            Détails de la saisie #{saisie.id}
          </h3>
          <div className="flex items-center space-x-3">
            <button 
              onClick={() => {
                onOpenBilling();
              }}
              className="btn-secondary flex items-center space-x-2"
            >
              <Printer className="h-4 w-4" />
              <span>Imprimer la pochette A3</span>
            </button>
            <button 
              onClick={() => onEdit(saisie)}
              className="btn-primary flex items-center space-x-2"
            >
              <Edit className="h-4 w-4" />
              <span>Modifier</span>
            </button>
            <button onClick={onClose} className="btn-secondary">
              <X className="h-5 w-5" />
            </button>
          </div>
        </div>

        {/* Aperçu des étapes */}
        <div className="card p-6 mb-6">
          <h4 className="text-xl font-semibold text-port-gray-900 mb-4 flex items-center">
            <Navigation className="h-6 w-6 mr-2" />
            Aperçu des étapes
          </h4>
          {renderStepsOverview()}
        </div>

        {/* Grid des informations */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          
          {/* Informations générales */}
          <div className="card p-6">
            <div className="flex items-center mb-4">
              <FileText className="h-8 w-8 text-atl-blue-600 mr-3" />
              <h4 className="text-lg font-semibold text-port-gray-900">Informations générales</h4>
            </div>
            <div className="space-y-3 text-sm">
              <div className="flex justify-between">
                <span className="text-port-gray-600">Client:</span>
                <span className="font-medium text-port-gray-900">{saisie.clientName || 'Non défini'}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-port-gray-600">N° dossier:</span>
                <span className="font-medium text-atl-green-600">{saisie.numeroDossier}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-port-gray-600">Bon livraison:</span>
                <span className="font-medium text-port-gray-900">{saisie.bonLivraison}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-port-gray-600">Commande client:</span>
                <span className="font-medium text-port-gray-900">{saisie.numeroCommande || 'Non défini'}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-port-gray-600">Statut:</span>
                <span className="font-medium text-port-gray-900">{saisie.shippingStatusLabel}</span>
              </div>
            </div>
          </div>

          {/* Contenu */}
          <div className="card p-6">
            <div className="flex items-center mb-4">
              <Package className="h-8 w-8 text-atl-blue-600 mr-3" />
              <h4 className="text-lg font-semibold text-port-gray-900">Contenu</h4>
            </div>
            <div className="space-y-3 text-sm">
              <div>
                <span className="text-port-gray-600">Description:</span>
                <p className="font-medium text-port-gray-900 mt-1">
                  {saisie.content?.description || 'Non définie'}
                </p>
              </div>
              <div className="flex justify-between">
                <span className="text-port-gray-600">Conditionnement:</span>
                <span className="font-medium text-port-gray-900">{saisie.content?.conditionnement || 'Non défini'}</span>
              </div>
              {saisie.content?.poids && (
                <div className="flex justify-between">
                  <span className="text-port-gray-600">Poids:</span>
                  <span className="font-medium text-port-gray-900">{saisie.content.poids}</span>
                </div>
              )}
                             {saisie.content?.dimensions && (
                 <div className="flex justify-between">
                   <span className="text-port-gray-600">Dimensions:</span>
                   <span className="font-medium text-port-gray-900">{saisie.content.dimensions}</span>
                 </div>
               )}
               {saisie.content?.nombreColis && (
                 <div className="flex justify-between">
                   <span className="text-port-gray-600">Nombre de colis:</span>
                   <span className="font-medium text-port-gray-900">{saisie.content.nombreColis}</span>
                 </div>
               )}
            </div>
          </div>

          {/* Transports */}
          <div className="card p-6">
            <div className="flex items-center mb-4">
              <Truck className="h-8 w-8 text-atl-blue-600 mr-3" />
              <h4 className="text-lg font-semibold text-port-gray-900">
                Transports ({saisie.transports?.length || 0})
              </h4>
            </div>
            {saisie.transports && saisie.transports.length > 0 ? (
              <div className="space-y-3 text-sm max-h-48 overflow-y-auto">
                {saisie.transports.map((transport, index) => (
                  <div key={transport.id} className="p-2 bg-port-gray-50 rounded">
                    <div className="font-medium text-port-gray-900">
                      {transport.transporteurName || 'Transporteur inconnu'}
                    </div>
                    <div className="text-port-gray-600 text-xs">
                      {transport.transporteurTrackingNumber || 'Pas de suivi'}
                      {transport.entryStepId && (transport.transportBeforeStep ? ' • Avant étape' : ' • Après étape')}
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <p className="text-port-gray-500 text-sm">Aucun transport défini</p>
            )}
          </div>

          {/* Documents de douane */}
          <div className="card p-6">
            <div className="flex items-center mb-4">
              <Shield className="h-8 w-8 text-yellow-600 mr-3" />
              <h4 className="text-lg font-semibold text-port-gray-900">
                Documents douane ({saisie.douaneDocuments?.length || 0})
              </h4>
            </div>
            {saisie.douaneDocuments && saisie.douaneDocuments.length > 0 ? (
              <div className="space-y-3 text-sm max-h-48 overflow-y-auto">
                {saisie.douaneDocuments.map((doc, index) => (
                  <div key={doc.id} className="p-2 bg-port-gray-50 rounded">
                    <div className="font-medium text-port-gray-900">
                      {doc.documentType} - {doc.documentNumber}
                    </div>
                    <div className="text-port-gray-600 text-xs">
                      {doc.supplierName || 'Fournisseur inconnu'}
                      {doc.price && ` • ${doc.price}€`}
                      {doc.apure && ' • Apuré'}
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <p className="text-port-gray-500 text-sm">Aucun document de douane</p>
            )}
          </div>

          {/* Documents généraux */}
          <div className="card p-6">
            <div className="flex items-center mb-4">
              <Upload className="h-8 w-8 text-purple-600 mr-3" />
              <h4 className="text-lg font-semibold text-port-gray-900">
                Documents ({saisie.documents?.length || 0})
              </h4>
            </div>
            {saisie.documents && saisie.documents.length > 0 ? (
              <div className="space-y-3 text-sm max-h-48 overflow-y-auto">
                {saisie.documents.map((doc, index) => (
                  <div key={doc.id} className="p-2 bg-port-gray-50 rounded">
                    <div className="font-medium text-port-gray-900">
                      {doc.type} - {doc.nomFichier}
                    </div>
                    <div className="text-port-gray-600 text-xs">
                      {doc.taille && `${Math.round(doc.taille / 1024)} KB`}
                      {doc.dateUpload && ` • ${new Date(doc.dateUpload).toLocaleDateString('fr-FR')}`}
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <p className="text-port-gray-500 text-sm">Aucun document</p>
            )}
          </div>

          {/* Notes */}
          {saisie.notes && (
            <div className="card p-6">
              <div className="flex items-center mb-4">
                <FileText className="h-8 w-8 text-port-gray-600 mr-3" />
                <h4 className="text-lg font-semibold text-port-gray-900">Notes</h4>
              </div>
              <p className="text-sm text-port-gray-700">{saisie.notes}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const Saisies = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('Tous');
  const [drydocFilter, setDrydocFilter] = useState(null);
  const [selectedSaisie, setSelectedSaisie] = useState(null);
  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
  const [isBillingModalOpen, setIsBillingModalOpen] = useState(false);
  const [selectedSaisies, setSelectedSaisies] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  // Données des drydocs pour le filtrage
  const drydocs = [
    {
      id: 1,
      customer_name: 'CMA CGM',
      customer_recipient_name: 'CMA CGM Marseille',
      imo_number: 'IMO1234567'
    },
    {
      id: 2,
      customer_name: 'MSC',
      customer_recipient_name: 'MSC Terminal',
      imo_number: 'IMO7654321'
    },
    {
      id: 4,
      customer_name: 'CMA CGM',
      customer_recipient_name: 'CMA CGM Marseille',
      imo_number: 'IMO9876543'
    }
  ];

  // Effect pour détecter le filtre drydoc depuis l'URL
  useEffect(() => {
    const drydocParam = searchParams.get('drydoc');
    if (drydocParam) {
      const drydocId = parseInt(drydocParam);
      const drydoc = drydocs.find(d => d.id === drydocId);
      if (drydoc) {
        setDrydocFilter(drydoc);
      }
    }
  }, [searchParams]);

  // Fonction pour supprimer le filtre drydoc
  const clearDrydocFilter = () => {
    setDrydocFilter(null);
    const newSearchParams = new URLSearchParams(searchParams);
    newSearchParams.delete('drydoc');
    setSearchParams(newSearchParams);
  };

  // Données d'exemple adaptées au nouveau modèle avec plus d'enregistrements
  const saisies = [
    {
      id: '21101',
      clientName: 'CMA CGM',
      drydocId: 1, // Lié au drydoc #1
      numeroDossier: '2112023',
      bonLivraison: 'BL-001-2024',
      numeroCommande: 'CMD-CMA-001',
      shippingStatusLabel: 'Entrepôt ATL',
      datePrevueEntreeEntrepot: '2024-01-15',
      dateLivraison: '2024-01-20',
      notes: 'Livraison pour drydoc CMA CGM Marseille',
      content: {
        description: 'Conteneur de pièces automobiles',
        conditionnement: 'Conteneur 40\'',
        poids: '2.5 tonnes',
        dimensions: '12.2 x 2.4 x 2.6 m',
        nombreColis: 1
      },
      steps: [
        {
          id: 'step-1',
          stepType: 'Origine',
          entityLinkedName: 'Port de Marseille',
          dateStep: '2024-01-10',
          sortOrder: 1
        },
        {
          id: 'step-2',
          stepType: 'Entrepot ATL',
          entityLinkedName: 'Entrepôt ATL',
          dateStep: '2024-01-15',
          sortOrder: 2
        },
        {
          id: 'step-3',
          stepType: 'Destination',
          entityLinkedName: 'CMA CGM Terminal',
          dateStep: '2024-01-20',
          sortOrder: 3
        }
      ],
      transports: [
        {
          id: 'transport-1',
          transporteurName: 'Transport Express',
          transporteurTrackingNumber: 'TE-123456',
          entryStepId: 'step-1',
          transportBeforeStep: false
        }
      ],
      douaneDocuments: [
        {
          id: 'douane-1',
          documentType: 'T1',
          documentNumber: 'T1-2024-001',
          supplierName: 'Douane France',
          price: 150,
          apure: true
        }
      ],
      documents: [
        {
          id: 'doc-1',
          type: 'Facture',
          nomFichier: 'facture-001.pdf',
          taille: 1024000,
          dateUpload: '2024-01-10T10:00:00Z'
        }
      ],
      status: 'Pré alerte'
    },
    {
      id: '21102',
      clientName: 'MSC',
      drydocId: 2, // Lié au drydoc #2
      numeroDossier: '2112024',
      bonLivraison: 'BL-002-2024',
      numeroCommande: 'CMD-MSC-001',
      shippingStatusLabel: 'Livré',
      datePrevueEntreeEntrepot: '2024-01-14',
      dateLivraison: '2024-01-18',
      notes: 'Livraison pour drydoc MSC Terminal',
      content: {
        description: 'Palette de marchandises diverses',
        conditionnement: 'Palette',
        poids: '1.8 tonnes',
        dimensions: '1.2 x 0.8 x 1.5 m',
        nombreColis: 12
      },
      steps: [
        {
          id: 'step-4',
          stepType: 'Origine',
          entityLinkedName: 'Fournisseur Italien',
          dateStep: '2024-01-12',
          sortOrder: 1
        },
        {
          id: 'step-5',
          stepType: 'Destination',
          entityLinkedName: 'MSC Terminal',
          dateStep: '2024-01-18',
          sortOrder: 2
        }
      ],
      transports: [],
      douaneDocuments: [],
      documents: [],
      status: 'Livré'
    },
    {
      id: '21103',
      clientName: 'Maersk',
      numeroDossier: '2112025',
      bonLivraison: 'BL-003-2024',
      numeroCommande: 'CMD-MAE-001',
      shippingStatusLabel: 'Entrepôt ATL Douane',
      datePrevueEntreeEntrepot: '2024-01-22',
      dateLivraison: '2024-01-28',
      notes: 'Marchandises sensibles',
      content: {
        description: 'Équipements électroniques',
        conditionnement: 'Cartons',
        poids: '0.8 tonnes',
        dimensions: '2.0 x 1.5 x 1.0 m',
        nombreColis: 8
      },
      steps: [
        {
          id: 'step-6',
          stepType: 'Origine',
          entityLinkedName: 'Port de Rotterdam',
          dateStep: '2024-01-20',
          sortOrder: 1
        },
        {
          id: 'step-7',
          stepType: 'Entrepot ATL Douane',
          entityLinkedName: 'Entrepôt ATL Douane',
          dateStep: '2024-01-22',
          sortOrder: 2
        }
      ],
      transports: [
        {
          id: 'transport-2',
          transporteurName: 'Logistics Pro',
          transporteurTrackingNumber: 'LP-789012',
          entryStepId: 'step-6',
          transportBeforeStep: false
        }
      ],
      douaneDocuments: [
        {
          id: 'douane-2',
          documentType: 'C88',
          documentNumber: 'C88-2024-002',
          supplierName: 'Douane Pays-Bas',
          price: 200,
          apure: false
        }
      ],
      documents: [
        {
          id: 'doc-2',
          type: 'Certificat',
          nomFichier: 'certificat-001.pdf',
          taille: 512000,
          dateUpload: '2024-01-20T14:30:00Z'
        }
      ],
      status: 'Entrepôt ATL Douane'
    },
    {
      id: '21104',
      clientName: 'Hapag-Lloyd',
      numeroDossier: '2112026',
      bonLivraison: 'BL-004-2024',
      numeroCommande: 'CMD-HAP-001',
      shippingStatusLabel: 'Entrepôt ATL Douane',
      datePrevueEntreeEntrepot: '2024-01-25',
      dateLivraison: '2024-01-30',
      notes: 'Contrôle douanier requis',
      content: {
        description: 'Produits textiles',
        conditionnement: 'Rouleaux',
        poids: '3.2 tonnes',
        dimensions: '8.0 x 2.0 x 2.0 m',
        nombreColis: 24
      },
      steps: [
        {
          id: 'step-8',
          stepType: 'Origine',
          entityLinkedName: 'Port de Hambourg',
          dateStep: '2024-01-23',
          sortOrder: 1
        },
        {
          id: 'step-9',
          stepType: 'Entrepot ATL Douane',
          entityLinkedName: 'Entrepôt ATL Douane',
          dateStep: '2024-01-25',
          sortOrder: 2
        }
      ],
      transports: [
        {
          id: 'transport-3',
          transporteurName: 'Euro Transport',
          transporteurTrackingNumber: 'ET-345678',
          entryStepId: 'step-8',
          transportBeforeStep: false
        }
      ],
      douaneDocuments: [
        {
          id: 'douane-3',
          documentType: 'EUR1',
          documentNumber: 'EUR1-2024-003',
          supplierName: 'Douane Allemagne',
          price: 180,
          apure: true
        }
      ],
      documents: [
        {
          id: 'doc-3',
          type: 'Manifeste',
          nomFichier: 'manifeste-001.pdf',
          taille: 2048000,
          dateUpload: '2024-01-23T09:15:00Z'
        }
      ],
      status: 'Entrepôt ATL'
    },
    {
      id: '21105',
      clientName: 'ONE',
      numeroDossier: '2112027',
      bonLivraison: 'BL-005-2024',
      numeroCommande: 'CMD-ONE-001',
      shippingStatusLabel: 'Colis réceptionné',
      datePrevueEntreeEntrepot: '2024-01-18',
      dateLivraison: '2024-01-25',
      notes: 'Livraison standard',
      content: {
        description: 'Machines industrielles',
        conditionnement: 'Caisse en bois',
        poids: '5.5 tonnes',
        dimensions: '4.0 x 3.0 x 2.5 m',
        nombreColis: 3
      },
      steps: [
        {
          id: 'step-10',
          stepType: 'Origine',
          entityLinkedName: 'Port de Yokohama',
          dateStep: '2024-01-15',
          sortOrder: 1
        },
        {
          id: 'step-11',
          stepType: 'Entrepot ATL',
          entityLinkedName: 'Entrepôt ATL',
          dateStep: '2024-01-18',
          sortOrder: 2
        },
        {
          id: 'step-12',
          stepType: 'Destination',
          entityLinkedName: 'ONE Terminal',
          dateStep: '2024-01-25',
          sortOrder: 3
        }
      ],
      transports: [
        {
          id: 'transport-4',
          transporteurName: 'Asia Express',
          transporteurTrackingNumber: 'AE-901234',
          entryStepId: 'step-10',
          transportBeforeStep: false
        }
      ],
      douaneDocuments: [
        {
          id: 'douane-4',
          documentType: 'T1',
          documentNumber: 'T1-2024-004',
          supplierName: 'Douane Japon',
          price: 300,
          apure: true
        }
      ],
      documents: [
        {
          id: 'doc-4',
          type: 'Packing List',
          nomFichier: 'packing-list-001.pdf',
          taille: 768000,
          dateUpload: '2024-01-15T11:45:00Z'
        }
      ],
      status: 'Terminée'
    },
    {
      id: '21106',
      clientName: 'Evergreen',
      numeroDossier: '2112028',
      bonLivraison: 'BL-006-2024',
      numeroCommande: 'CMD-EVE-001',
      shippingStatusLabel: 'Pré alerte',
      datePrevueEntreeEntrepot: '2024-01-30',
      dateLivraison: '2024-02-05',
      notes: 'Nouvelle expédition',
      content: {
        description: 'Produits chimiques',
        conditionnement: 'Fûts',
        poids: '1.5 tonnes',
        dimensions: '3.0 x 2.0 x 1.5 m',
        nombreColis: 6
      },
      steps: [
        {
          id: 'step-13',
          stepType: 'Origine',
          entityLinkedName: 'Port de Kaohsiung',
          dateStep: '2024-01-28',
          sortOrder: 1
        }
      ],
      transports: [],
      douaneDocuments: [],
      documents: [],
      status: 'Pré alerte'
    },
    {
      id: '21104',
      clientName: 'CMA CGM',
      drydocId: 1, // Autre saisie pour le drydoc #1
      numeroDossier: '2112025',
      bonLivraison: 'BL-004-2024',
      numeroCommande: 'CMD-CMA-002',
      shippingStatusLabel: 'Colis réceptionné',
      datePrevueEntreeEntrepot: '2024-02-02',
      dateLivraison: '2024-02-05',
      notes: 'Pièces de rechange pour drydoc CMA CGM Marseille',
      content: {
        description: 'Pièces mécaniques diverses',
        conditionnement: 'Cartons',
        poids: '0.5 tonnes',
        dimensions: '2.0 x 1.0 x 1.0 m',
        nombreColis: 15
      },
      steps: [
        {
          id: 'step-drydoc-1',
          stepType: 'Destination',
          entityLinkedName: 'CMA CGM Marseille (Drydoc)',
          dateStep: '2024-02-05',
          sortOrder: 1
        }
      ],
      transports: [],
      douaneDocuments: [],
      documents: [],
      status: 'Colis réceptionné'
    },
    {
      id: '21105',
      clientName: 'MSC',
      drydocId: 2, // Autre saisie pour le drydoc #2
      numeroDossier: '2112026',
      bonLivraison: 'BL-005-2024',
      numeroCommande: 'CMD-MSC-002',
      shippingStatusLabel: 'Entrepôt ATL',
      datePrevueEntreeEntrepot: '2024-02-12',
      dateLivraison: '2024-02-16',
      notes: 'Matériel de peinture pour drydoc MSC Terminal',
      content: {
        description: 'Peinture marine et outils',
        conditionnement: 'Fûts',
        poids: '1.2 tonnes',
        dimensions: '1.5 x 1.5 x 2.0 m',
        nombreColis: 8
      },
      steps: [
        {
          id: 'step-drydoc-2',
          stepType: 'Destination',
          entityLinkedName: 'MSC Terminal (Drydoc)',
          dateStep: '2024-02-16',
          sortOrder: 1
        }
      ],
      transports: [],
      douaneDocuments: [],
      documents: [],
      status: 'Entrepôt ATL'
    }
  ];

  const filteredSaisies = saisies.filter(saisie => {
    const matchesSearch = 
      saisie.id.toLowerCase().includes(searchTerm.toLowerCase()) ||
      saisie.clientName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      saisie.bonLivraison.toLowerCase().includes(searchTerm.toLowerCase()) ||
      saisie.numeroCommande.toLowerCase().includes(searchTerm.toLowerCase());
    
    const matchesStatus = statusFilter === 'Tous' || saisie.status === statusFilter;
    
    const matchesDrydoc = !drydocFilter || saisie.drydocId === drydocFilter.id;
    
    return matchesSearch && matchesStatus && matchesDrydoc;
  });

  const getStatusColor = (status) => {
    switch (status) {
      case 'Livré':
        return 'bg-atl-green-100 text-atl-green-800';
      case 'Entrepôt ATL':
      case 'Entrepôt ATL Douane':
          return 'bg-atl-blue-100 text-atl-blue-800';
      case 'Pré alerte':
        return 'bg-yellow-100 text-yellow-800';
      default:
        return 'bg-port-gray-100 text-port-gray-800';
    }
  };

  const handleViewSaisie = (saisie) => {
    setSelectedSaisie(saisie);
    setIsDetailModalOpen(true);
  };

  const handleEditSaisie = (saisie) => {
    setIsDetailModalOpen(false); // Fermer le modal si ouvert
    navigate(`/modifier-saisie/${saisie.id}`);
  };

  const handleCloseModal = () => {
    setIsDetailModalOpen(false);
    setSelectedSaisie(null);
  };

  const handleCloseBillingModal = () => {
    setIsBillingModalOpen(false);
  };

  const handleOpenBillingModal = () => {
    setIsBillingModalOpen(true);
  };

  const handlePrintWithBilling = (billingData) => {
    // Ici vous pouvez implémenter la logique d'impression avec les données de facturation
    console.log('Impression de la pochette A3 avec données de facturation:', {
      saisie: selectedSaisie,
      billing: billingData
    });
    alert(`Impression de la pochette A3 pour la saisie ${selectedSaisie.id} avec les éléments de facturation`);
  };

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedSaisies([]);
      setSelectAll(false);
    } else {
      setSelectedSaisies(filteredSaisies.map(s => s.id));
      setSelectAll(true);
    }
  };

  const handleSelectSaisie = (saisieId) => {
    if (selectedSaisies.includes(saisieId)) {
      setSelectedSaisies(selectedSaisies.filter(id => id !== saisieId));
      setSelectAll(false);
    } else {
      const newSelected = [...selectedSaisies, saisieId];
      setSelectedSaisies(newSelected);
      if (newSelected.length === filteredSaisies.length) {
        setSelectAll(true);
      }
    }
  };

  const handleBulkEditBL = () => {
    if (selectedSaisies.length === 0) return;
    
    // Ici vous pouvez implémenter la logique d'édition en lot
    // Par exemple, ouvrir un modal avec les saisies sélectionnées
    console.log('Édition en lot des BL:', selectedSaisies);
    alert(`Édition en lot de ${selectedSaisies.length} bon(s) de livraison`);
  };

  const handleBulkDelete = () => {
    if (selectedSaisies.length === 0) return;
    
    if (window.confirm(`Êtes-vous sûr de vouloir supprimer ${selectedSaisies.length} saisie(s) ?`)) {
      // Ici vous pouvez implémenter la logique de suppression en lot
      console.log('Suppression en lot des saisies:', selectedSaisies);
      alert(`${selectedSaisies.length} saisie(s) supprimée(s)`);
      
      // Vider la sélection
      setSelectedSaisies([]);
      setSelectAll(false);
    }
  };

  return (
    <div className="space-y-6">
      {/* En-tête */}
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold text-port-gray-900">
            {drydocFilter 
              ? `Saisies - Drydoc #${drydocFilter.id}` 
              : 'Gestion des saisies'
            }
          </h1>
          <p className="text-port-gray-600">
            {drydocFilter 
              ? `Saisies concernant le drydoc ${drydocFilter.customer_recipient_name}` 
              : 'Suivi et gestion des saisies ATL'
            }
          </p>
        </div>
        <button 
          onClick={() => navigate('/nouvelle-saisie')}
          className="btn-primary flex items-center space-x-2"
        >
          <Plus className="h-5 w-5" />
          <span>Nouvelle saisie</span>
        </button>
      </div>

      {/* Filtres et recherche */}
      <div className="card p-6">
        <div className="flex flex-col md:flex-row gap-4">
          <div className="flex-1">
            <div className="relative">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-port-gray-400" />
              <input
                type="text"
                placeholder="Rechercher par ID, client, bon de livraison..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="input-field pl-10"
              />
            </div>
          </div>
          <div className="flex gap-4">
            <select
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
              className="input-field"
            >
              <option value="Tous">Tous les statuts</option>
              <option value="Pré alerte">Pré alerte</option>
              <option value="Colis réceptionné">Colis réceptionné</option>
              <option value="Entrepôt ATL">Entrepôt ATL</option>
              <option value="Entrepôt ATL douane">Entrepôt ATL douane</option>
              <option value="Livré">Livré</option>

            </select>
            <button className="btn-secondary flex items-center space-x-2">
              <Filter className="h-5 w-5" />
              <span>Filtres</span>
            </button>
          </div>
        </div>
        
        {/* Indicateur de filtre drydoc actif */}
        {drydocFilter && (
          <div className="mt-4 flex items-center space-x-2">
            <div className="flex items-center bg-atl-blue-100 text-atl-blue-800 px-3 py-2 rounded-lg">
              <Ship className="h-4 w-4 mr-2" />
              <span className="text-sm font-medium">
                Filtré par Drydoc #{drydocFilter.id}: {drydocFilter.customer_recipient_name}
              </span>
              <button
                onClick={clearDrydocFilter}
                className="ml-2 text-atl-blue-600 hover:text-atl-blue-800"
                title="Supprimer le filtre drydoc"
              >
                <X className="h-4 w-4" />
              </button>
            </div>
          </div>
        )}
      </div>

      {/* Actions en lot */}
      {selectedSaisies.length > 0 && (
        <div className="card p-4 bg-atl-blue-50 border-atl-blue-200">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <span className="text-sm font-medium text-atl-blue-800">
                {selectedSaisies.length} saisie(s) sélectionnée(s)
              </span>
            </div>
            <div className="flex items-center space-x-3">
              <button 
                onClick={handleBulkEditBL}
                className="btn-primary flex items-center space-x-2"
              >
                <FileEdit className="h-4 w-4" />
                <span>Édition de BL</span>
              </button>
              <button 
                onClick={handleBulkDelete}
                className="btn-danger flex items-center space-x-2"
              >
                <Trash2 className="h-4 w-4" />
                <span>Suppression</span>
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Tableau des saisies */}
      <div className="card overflow-hidden">
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-port-gray-200">
            <thead className="bg-port-gray-50">
              <tr>
                <th className="table-header px-6 py-3 text-left">
                  <input
                    type="checkbox"
                    checked={selectAll}
                    onChange={handleSelectAll}
                    className="h-4 w-4 text-atl-blue-600 border-port-gray-300 rounded focus:ring-atl-blue-500"
                  />
                </th>
                <th className="table-header px-6 py-3 text-left">ID Saisie</th>
                <th className="table-header px-6 py-3 text-left">N° Dossier</th>
                <th className="table-header px-6 py-3 text-left">Client</th>
                <th className="table-header px-6 py-3 text-left">Bon Livraison</th>
                <th className="table-header px-6 py-3 text-left">Nombre de Colis</th>
                <th className="table-header px-6 py-3 text-left">Conditionnement</th>
                <th className="table-header px-6 py-3 text-left">Date Prévue</th>
                <th className="table-header px-6 py-3 text-left">Statut</th>
                <th className="table-header px-6 py-3 text-left">Actions</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-port-gray-200">
              {filteredSaisies.map((saisie) => (
                <tr key={saisie.id} className="table-row">
                  <td className="px-6 py-4 whitespace-nowrap">
                    <input
                      type="checkbox"
                      checked={selectedSaisies.includes(saisie.id)}
                      onChange={() => handleSelectSaisie(saisie.id)}
                      className="h-4 w-4 text-atl-blue-600 border-port-gray-300 rounded focus:ring-atl-blue-500"
                    />
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="flex items-center">
                      <Package className="h-5 w-5 text-atl-blue-600 mr-2" />
                      <span className="font-medium text-port-gray-900">{saisie.id}</span>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <span className="font-medium text-atl-green-600">{saisie.numeroDossier}</span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="flex items-center">
                      <User className="h-4 w-4 text-port-gray-400 mr-2" />
                      <span className="text-port-gray-900">{saisie.clientName}</span>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <span className="text-port-gray-900">{saisie.bonLivraison}</span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <span className="text-port-gray-900">{saisie.content?.nombreColis || 'Non défini'}</span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <span className="text-port-gray-900">{saisie.content?.conditionnement || 'Non défini'}</span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="flex items-center">
                      <Calendar className="h-4 w-4 text-port-gray-400 mr-2" />
                      <span className="text-port-gray-900">
                        {saisie.datePrevueEntreeEntrepot ? new Date(saisie.datePrevueEntreeEntrepot).toLocaleDateString('fr-FR') : 'Non définie'}
                      </span>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <span className={`inline-flex px-2 py-1 text-xs font-medium rounded-full ${getStatusColor(saisie.status)}`}>
                      {saisie.status}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="flex items-center space-x-2">
                      <button 
                        onClick={() => handleViewSaisie(saisie)}
                        className="text-atl-blue-600 hover:text-atl-blue-700"
                        title="Voir les détails"
                      >
                        <Eye className="h-4 w-4" />
                      </button>
                      <button 
                        onClick={() => handleEditSaisie(saisie)}
                        className="text-port-gray-600 hover:text-port-gray-700"
                        title="Modifier"
                      >
                        <Edit className="h-4 w-4" />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Pagination */}
      <div className="flex items-center justify-between">
        <div className="text-sm text-port-gray-700">
          Affichage de <span className="font-medium">1</span> à <span className="font-medium">{filteredSaisies.length}</span> sur <span className="font-medium">{saisies.length}</span> résultats
        </div>
        <div className="flex items-center space-x-2">
          <button className="btn-secondary">Précédent</button>
          <button className="btn-primary">Suivant</button>
        </div>
      </div>

      {/* Modal de détails */}
      <SaisieDetailModal
        isOpen={isDetailModalOpen}
        saisie={selectedSaisie}
        onClose={handleCloseModal}
        onEdit={handleEditSaisie}
        onOpenBilling={handleOpenBillingModal}
      />

      {/* Modal de facturation */}
      <BillingModal
        isOpen={isBillingModalOpen}
        saisie={selectedSaisie}
        onClose={handleCloseBillingModal}
        onPrint={handlePrintWithBilling}
      />
    </div>
  );
};

export default Saisies;
